import AccountService from "./account";
import UnityService from "./unity";
import PersonService from "./person";
import EquipmentService from "./equipment";

function token() {
  return localStorage.access_token
}

const baseUrl = process.env.VUE_APP_API_URL || 'http://localhost:81'
const services = {
  account: AccountService,
  unity: UnityService,
  person: PersonService,
  equipment: EquipmentService

};

export default {
  get: name => new services[name](token, baseUrl)
};
